import type { IActionsProps } from 'shared/ui'

export const requestsAccessActionConfig: Partial<IActionsProps> = {
  noVisibleActions: false,
  isButton: true,
  showItems: 2,
  gap: 8,
  commonButtonProps: {
    size: 'small',
  },
}
